import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

export const logGAEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams ?? {});
    console.log('GA Event logged:', eventName, eventParams);
  } else {
    console.warn('gtag not initialized:', eventName, eventParams);
  }
};

export default function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_TRACKING_ID) {
      console.warn('Google Analytics Tracking ID is missing.');
      return;
    }

    window.dataLayer = window.dataLayer || [];

    // Skip re-injecting gtag.js if another script on the page already
    // loaded it — our config call below piggy-backs onto the existing
    // instance via the shared dataLayer.
    const alreadyLoaded = !!document.querySelector(
      'script[src*="googletagmanager.com/gtag/js"]'
    );
    if (!alreadyLoaded) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      script.async = true;
      document.head.appendChild(script);
    }

    // Local helper for queuing init calls. Deliberately not assigned to
    // window.gtag — gtag.js installs the real window.gtag itself once it
    // loads, and overwriting it (even with a stub) silently breaks tracking
    // for every snippet on the page.
    const gtag = (...args: unknown[]) => {
      window.dataLayer.push(args);
    };

    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID);
    console.log('GA Tracking ID:', GA_TRACKING_ID);
  }, []);

  return null;
}
